var _path;

var _excluded = ["title", "titleId"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlob(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 96.5261 39.4989 C 96.5261 61.5903 69.6168 90.9998 47.5254 90.9998 C 25.434 90.9998 0.525391 71.0913 0.525391 48.9999 C -0.974306 16.9999 31.0261 -2.00175 59.0254 0.499155 C 81.1168 0.499155 96.5261 17.4075 96.5261 39.4989 Z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob);
export default __webpack_public_path__ + "static/media/blob.4170c64571380a9b91eb42910a2a24ec.svg";
export { ForwardRef as ReactComponent };